import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class MenuVue extends Vue {

  addText(): void {
    this.$emit('addText')
  }

  onFileUploaded(event: Event): void {
    const input: HTMLInputElement = <HTMLInputElement>event.target
    const images = input.files || []
    this.$emit('addImage', images)
    input.value = ''
  }

  addEmbed(): void {
    this.$emit('addEmbed')
  }

  addUrl(): void {
    this.$emit('addUrl')
  }

}
